// @ts-nocheck

import styled, { css } from 'styled-components'
import { ReactComponent as LocationFile } from '../../assets/icons/location.svg'
import { ReactComponent as ChevronDownFile } from '../../assets/icons/chevron-down.svg'

export const MOBILE_BOTTOM_NAV_HEIGHT = 65
export const MOBILE_LOCATION_BAR_HEIGHT = 44

export const Container = styled.div`
  ${({ theme }) => css`
    position: fixed;
    bottom: ${MOBILE_BOTTOM_NAV_HEIGHT}px;
    left: 0;
    right: 0;
    height: ${MOBILE_LOCATION_BAR_HEIGHT}px;
    background: #f4f4f4;
    border-top: 1px solid #dfdfdf;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 700;
    cursor: pointer;
    padding: 0 ${theme.spacing.stack.xxs};
  `}
`

export const LocationWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 100%;

    > p {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 0 ${theme.spacing.stack.small};
    }
  `}
`

export const LocationIcon = styled(LocationFile)`
  fill: #8601c9;
  width: 24px;
  min-width: 24px;
`

export const ChevronDownIcon = styled(ChevronDownFile)`
  fill: #6c01a3;
  width: 16px;
  min-width: 16px;
`
